module.exports = {
  "ar.json": {
    "src": require("../i18n/ar.json"),
    "size": 2719,
    "mtime": "2020-05-21T20:31:18.946Z",
    [Symbol.for("__location__")]: [
      "ar.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ar.json", function() { cb(require("../i18n/ar.json")); });})
  },
  "ast.json": {
    "src": require("../i18n/ast.json"),
    "size": 2249,
    "mtime": "2020-05-21T20:31:18.966Z",
    [Symbol.for("__location__")]: [
      "ast.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ast.json", function() { cb(require("../i18n/ast.json")); });})
  },
  "azb.json": {
    "src": require("../i18n/azb.json"),
    "size": 541,
    "mtime": "2018-06-04T21:43:18.204Z",
    [Symbol.for("__location__")]: [
      "azb.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/azb.json", function() { cb(require("../i18n/azb.json")); });})
  },
  "bcl.json": {
    "src": require("../i18n/bcl.json"),
    "size": 1504,
    "mtime": "2019-08-14T09:51:45.012Z",
    [Symbol.for("__location__")]: [
      "bcl.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/bcl.json", function() { cb(require("../i18n/bcl.json")); });})
  },
  "be-tarask.json": {
    "src": require("../i18n/be-tarask.json"),
    "size": 3292,
    "mtime": "2019-01-30T23:24:15.260Z",
    [Symbol.for("__location__")]: [
      "be-tarask.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/be-tarask.json", function() { cb(require("../i18n/be-tarask.json")); });})
  },
  "bg.json": {
    "src": require("../i18n/bg.json"),
    "size": 1492,
    "mtime": "2019-05-31T18:04:37.177Z",
    [Symbol.for("__location__")]: [
      "bg.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/bg.json", function() { cb(require("../i18n/bg.json")); });})
  },
  "bn.json": {
    "src": require("../i18n/bn.json"),
    "size": 2006,
    "mtime": "2019-08-14T09:51:45.024Z",
    [Symbol.for("__location__")]: [
      "bn.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/bn.json", function() { cb(require("../i18n/bn.json")); });})
  },
  "br.json": {
    "src": require("../i18n/br.json"),
    "size": 2415,
    "mtime": "2020-05-21T20:31:18.982Z",
    [Symbol.for("__location__")]: [
      "br.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/br.json", function() { cb(require("../i18n/br.json")); });})
  },
  "bs.json": {
    "src": require("../i18n/bs.json"),
    "size": 412,
    "mtime": "2018-06-04T21:43:18.212Z",
    [Symbol.for("__location__")]: [
      "bs.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/bs.json", function() { cb(require("../i18n/bs.json")); });})
  },
  "ca.json": {
    "src": require("../i18n/ca.json"),
    "size": 558,
    "mtime": "2018-07-10T20:50:38.255Z",
    [Symbol.for("__location__")]: [
      "ca.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ca.json", function() { cb(require("../i18n/ca.json")); });})
  },
  "ckb.json": {
    "src": require("../i18n/ckb.json"),
    "size": 1952,
    "mtime": "2020-05-21T20:31:18.994Z",
    [Symbol.for("__location__")]: [
      "ckb.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ckb.json", function() { cb(require("../i18n/ckb.json")); });})
  },
  "cs.json": {
    "src": require("../i18n/cs.json"),
    "size": 1772,
    "mtime": "2020-05-21T20:31:19.002Z",
    [Symbol.for("__location__")]: [
      "cs.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/cs.json", function() { cb(require("../i18n/cs.json")); });})
  },
  "da.json": {
    "src": require("../i18n/da.json"),
    "size": 1725,
    "mtime": "2019-01-30T23:24:15.280Z",
    [Symbol.for("__location__")]: [
      "da.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/da.json", function() { cb(require("../i18n/da.json")); });})
  },
  "de.json": {
    "src": require("../i18n/de.json"),
    "size": 2402,
    "mtime": "2019-01-30T23:24:15.284Z",
    [Symbol.for("__location__")]: [
      "de.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/de.json", function() { cb(require("../i18n/de.json")); });})
  },
  "diq.json": {
    "src": require("../i18n/diq.json"),
    "size": 2355,
    "mtime": "2020-05-21T20:31:19.014Z",
    [Symbol.for("__location__")]: [
      "diq.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/diq.json", function() { cb(require("../i18n/diq.json")); });})
  },
  "el.json": {
    "src": require("../i18n/el.json"),
    "size": 2669,
    "mtime": "2020-05-21T20:31:19.026Z",
    [Symbol.for("__location__")]: [
      "el.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/el.json", function() { cb(require("../i18n/el.json")); });})
  },
  "en.json": {
    "src": require("../i18n/en.json"),
    "size": 2105,
    "mtime": "2020-05-21T18:35:07.136Z",
    [Symbol.for("__location__")]: [
      "en.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/en.json", function() { cb(require("../i18n/en.json")); });})
  },
  "eo.json": {
    "src": require("../i18n/eo.json"),
    "size": 2200,
    "mtime": "2019-05-31T18:04:37.209Z",
    [Symbol.for("__location__")]: [
      "eo.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/eo.json", function() { cb(require("../i18n/eo.json")); });})
  },
  "es.json": {
    "src": require("../i18n/es.json"),
    "size": 2425,
    "mtime": "2019-05-31T18:04:37.221Z",
    [Symbol.for("__location__")]: [
      "es.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/es.json", function() { cb(require("../i18n/es.json")); });})
  },
  "eu.json": {
    "src": require("../i18n/eu.json"),
    "size": 1744,
    "mtime": "2020-05-21T20:31:19.042Z",
    [Symbol.for("__location__")]: [
      "eu.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/eu.json", function() { cb(require("../i18n/eu.json")); });})
  },
  "fa.json": {
    "src": require("../i18n/fa.json"),
    "size": 991,
    "mtime": "2019-05-31T18:04:37.273Z",
    [Symbol.for("__location__")]: [
      "fa.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/fa.json", function() { cb(require("../i18n/fa.json")); });})
  },
  "fi.json": {
    "src": require("../i18n/fi.json"),
    "size": 1722,
    "mtime": "2019-05-31T18:04:37.285Z",
    [Symbol.for("__location__")]: [
      "fi.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/fi.json", function() { cb(require("../i18n/fi.json")); });})
  },
  "fr.json": {
    "src": require("../i18n/fr.json"),
    "size": 2511,
    "mtime": "2020-05-21T20:31:19.066Z",
    [Symbol.for("__location__")]: [
      "fr.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/fr.json", function() { cb(require("../i18n/fr.json")); });})
  },
  "gl.json": {
    "src": require("../i18n/gl.json"),
    "size": 1048,
    "mtime": "2018-07-26T20:34:40.936Z",
    [Symbol.for("__location__")]: [
      "gl.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/gl.json", function() { cb(require("../i18n/gl.json")); });})
  },
  "he.json": {
    "src": require("../i18n/he.json"),
    "size": 2741,
    "mtime": "2019-01-30T23:24:15.312Z",
    [Symbol.for("__location__")]: [
      "he.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/he.json", function() { cb(require("../i18n/he.json")); });})
  },
  "hi.json": {
    "src": require("../i18n/hi.json"),
    "size": 4207,
    "mtime": "2019-01-30T23:24:15.316Z",
    [Symbol.for("__location__")]: [
      "hi.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/hi.json", function() { cb(require("../i18n/hi.json")); });})
  },
  "hyw.json": {
    "src": require("../i18n/hyw.json"),
    "size": 3250,
    "mtime": "2020-05-21T20:31:19.094Z",
    [Symbol.for("__location__")]: [
      "hyw.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/hyw.json", function() { cb(require("../i18n/hyw.json")); });})
  },
  "it.json": {
    "src": require("../i18n/it.json"),
    "size": 754,
    "mtime": "2019-01-30T23:24:15.328Z",
    [Symbol.for("__location__")]: [
      "it.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/it.json", function() { cb(require("../i18n/it.json")); });})
  },
  "ja.json": {
    "src": require("../i18n/ja.json"),
    "size": 1465,
    "mtime": "2019-01-30T23:24:15.332Z",
    [Symbol.for("__location__")]: [
      "ja.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ja.json", function() { cb(require("../i18n/ja.json")); });})
  },
  "kab.json": {
    "src": require("../i18n/kab.json"),
    "size": 1321,
    "mtime": "2020-05-21T18:35:10.556Z",
    [Symbol.for("__location__")]: [
      "kab.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/kab.json", function() { cb(require("../i18n/kab.json")); });})
  },
  "ko.json": {
    "src": require("../i18n/ko.json"),
    "size": 1966,
    "mtime": "2020-05-21T20:31:19.114Z",
    [Symbol.for("__location__")]: [
      "ko.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ko.json", function() { cb(require("../i18n/ko.json")); });})
  },
  "ku-latn.json": {
    "src": require("../i18n/ku-latn.json"),
    "size": 1811,
    "mtime": "2020-05-21T20:31:19.134Z",
    [Symbol.for("__location__")]: [
      "ku-latn.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ku-latn.json", function() { cb(require("../i18n/ku-latn.json")); });})
  },
  "kum.json": {
    "src": require("../i18n/kum.json"),
    "size": 975,
    "mtime": "2018-07-10T20:50:38.431Z",
    [Symbol.for("__location__")]: [
      "kum.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/kum.json", function() { cb(require("../i18n/kum.json")); });})
  },
  "lb.json": {
    "src": require("../i18n/lb.json"),
    "size": 1045,
    "mtime": "2020-05-21T20:31:19.142Z",
    [Symbol.for("__location__")]: [
      "lb.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/lb.json", function() { cb(require("../i18n/lb.json")); });})
  },
  "li.json": {
    "src": require("../i18n/li.json"),
    "size": 1662,
    "mtime": "2018-07-10T20:50:38.455Z",
    [Symbol.for("__location__")]: [
      "li.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/li.json", function() { cb(require("../i18n/li.json")); });})
  },
  "lt.json": {
    "src": require("../i18n/lt.json"),
    "size": 729,
    "mtime": "2020-05-21T20:31:19.162Z",
    [Symbol.for("__location__")]: [
      "lt.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/lt.json", function() { cb(require("../i18n/lt.json")); });})
  },
  "mk.json": {
    "src": require("../i18n/mk.json"),
    "size": 3327,
    "mtime": "2019-05-31T18:04:37.293Z",
    [Symbol.for("__location__")]: [
      "mk.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/mk.json", function() { cb(require("../i18n/mk.json")); });})
  },
  "mnw.json": {
    "src": require("../i18n/mnw.json"),
    "size": 540,
    "mtime": "2019-01-30T23:24:15.352Z",
    [Symbol.for("__location__")]: [
      "mnw.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/mnw.json", function() { cb(require("../i18n/mnw.json")); });})
  },
  "my.json": {
    "src": require("../i18n/my.json"),
    "size": 2218,
    "mtime": "2019-01-30T23:24:15.360Z",
    [Symbol.for("__location__")]: [
      "my.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/my.json", function() { cb(require("../i18n/my.json")); });})
  },
  "nb.json": {
    "src": require("../i18n/nb.json"),
    "size": 2244,
    "mtime": "2019-01-30T23:24:15.364Z",
    [Symbol.for("__location__")]: [
      "nb.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/nb.json", function() { cb(require("../i18n/nb.json")); });})
  },
  "ne.json": {
    "src": require("../i18n/ne.json"),
    "size": 1777,
    "mtime": "2019-01-30T23:24:15.368Z",
    [Symbol.for("__location__")]: [
      "ne.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ne.json", function() { cb(require("../i18n/ne.json")); });})
  },
  "nl.json": {
    "src": require("../i18n/nl.json"),
    "size": 584,
    "mtime": "2020-05-21T20:31:19.170Z",
    [Symbol.for("__location__")]: [
      "nl.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/nl.json", function() { cb(require("../i18n/nl.json")); });})
  },
  "pl.json": {
    "src": require("../i18n/pl.json"),
    "size": 1786,
    "mtime": "2020-05-21T20:31:19.186Z",
    [Symbol.for("__location__")]: [
      "pl.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/pl.json", function() { cb(require("../i18n/pl.json")); });})
  },
  "pt-br.json": {
    "src": require("../i18n/pt-br.json"),
    "size": 2371,
    "mtime": "2020-05-21T20:31:19.198Z",
    [Symbol.for("__location__")]: [
      "pt-br.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/pt-br.json", function() { cb(require("../i18n/pt-br.json")); });})
  },
  "pt.json": {
    "src": require("../i18n/pt.json"),
    "size": 2417,
    "mtime": "2019-01-30T23:24:15.380Z",
    [Symbol.for("__location__")]: [
      "pt.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/pt.json", function() { cb(require("../i18n/pt.json")); });})
  },
  "qqq.json": {
    "src": require("../i18n/qqq.json"),
    "size": 3333,
    "mtime": "2020-05-21T20:31:19.210Z",
    [Symbol.for("__location__")]: [
      "qqq.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/qqq.json", function() { cb(require("../i18n/qqq.json")); });})
  },
  "roa-tara.json": {
    "src": require("../i18n/roa-tara.json"),
    "size": 2421,
    "mtime": "2020-05-21T20:31:19.214Z",
    [Symbol.for("__location__")]: [
      "roa-tara.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/roa-tara.json", function() { cb(require("../i18n/roa-tara.json")); });})
  },
  "ru.json": {
    "src": require("../i18n/ru.json"),
    "size": 3197,
    "mtime": "2020-05-21T20:31:19.226Z",
    [Symbol.for("__location__")]: [
      "ru.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/ru.json", function() { cb(require("../i18n/ru.json")); });})
  },
  "sh.json": {
    "src": require("../i18n/sh.json"),
    "size": 2269,
    "mtime": "2019-05-31T18:04:37.333Z",
    [Symbol.for("__location__")]: [
      "sh.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/sh.json", function() { cb(require("../i18n/sh.json")); });})
  },
  "skr-arab.json": {
    "src": require("../i18n/skr-arab.json"),
    "size": 644,
    "mtime": "2019-01-30T23:24:15.400Z",
    [Symbol.for("__location__")]: [
      "skr-arab.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/skr-arab.json", function() { cb(require("../i18n/skr-arab.json")); });})
  },
  "sr-ec.json": {
    "src": require("../i18n/sr-ec.json"),
    "size": 3160,
    "mtime": "2020-05-21T20:31:19.238Z",
    [Symbol.for("__location__")]: [
      "sr-ec.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/sr-ec.json", function() { cb(require("../i18n/sr-ec.json")); });})
  },
  "sv.json": {
    "src": require("../i18n/sv.json"),
    "size": 2255,
    "mtime": "2019-01-30T23:24:15.408Z",
    [Symbol.for("__location__")]: [
      "sv.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/sv.json", function() { cb(require("../i18n/sv.json")); });})
  },
  "tr.json": {
    "src": require("../i18n/tr.json"),
    "size": 2475,
    "mtime": "2020-05-21T20:31:19.258Z",
    [Symbol.for("__location__")]: [
      "tr.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/tr.json", function() { cb(require("../i18n/tr.json")); });})
  },
  "uk.json": {
    "src": require("../i18n/uk.json"),
    "size": 3385,
    "mtime": "2020-05-21T20:31:19.262Z",
    [Symbol.for("__location__")]: [
      "uk.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/uk.json", function() { cb(require("../i18n/uk.json")); });})
  },
  "vi.json": {
    "src": require("../i18n/vi.json"),
    "size": 2741,
    "mtime": "2019-08-14T09:51:45.040Z",
    [Symbol.for("__location__")]: [
      "vi.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/vi.json", function() { cb(require("../i18n/vi.json")); });})
  },
  "zgh.json": {
    "src": require("../i18n/zgh.json"),
    "size": 972,
    "mtime": "2018-08-10T17:56:56.274Z",
    [Symbol.for("__location__")]: [
      "zgh.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/zgh.json", function() { cb(require("../i18n/zgh.json")); });})
  },
  "zh-hans.json": {
    "src": require("../i18n/zh-hans.json"),
    "size": 2164,
    "mtime": "2020-05-21T20:31:19.302Z",
    [Symbol.for("__location__")]: [
      "zh-hans.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/zh-hans.json", function() { cb(require("../i18n/zh-hans.json")); });})
  },
  "zh-hant.json": {
    "src": require("../i18n/zh-hant.json"),
    "size": 2181,
    "mtime": "2019-01-30T23:24:15.436Z",
    [Symbol.for("__location__")]: [
      "zh-hant.json"
    ],
    [Symbol.for("__type__")]: "file",
    "__onHMRUpdate__": (function(cb) { module.hot.accept("../i18n/zh-hant.json", function() { cb(require("../i18n/zh-hant.json")); });})
  },
  [Symbol.for("__type__")]: "directory",
  [Symbol.for("__location__")]: []
};


// WEBPACK FOOTER //
// ./i18n.dir.js